import style from './css'

const iGamingCanada = {
  label: 'iGaming Canada',
  includeInShowcase: true,
  config: {
    environment: 'test',
    userId: 'PayTestCA',
    merchantId: 198003,
    sessionId: '123',
    country: 'BRA',
    amountFirst: false,
    method: 'deposit',
    locale: 'en_US',
    selectlastusedtxmethod: false,
    storeAccount: true,
    showAccounts: 'inline',
    mode: 'gambling',
    additionalCashierText: true,
    amount: 25,
    receiptAmountDisplayStyle: 'symbol',
    receiptAmountTransactionStyle: 'TxAmount',
    receiptExcludeKeys: [
      'txRefId'
    ],
    feeAmount: [],
    layout: 'horizontal',
    showHeader: false,
    showFooter: true,
    containerHeight: '800px',
    containerWidth: '900px',
    bonusCode: 'Welcome100',
    channelId: 'AndroidBrowser',
    listRadio: true,
    predefinedValues: true,
    predefinedAmounts: [
      10,
      25,
      50,
      100,
      250,
      500
    ],
    providerType: null,
    isMobile: false,
    tabs: true,
    logoUrl: 'https://static.paymentiq.io/misc/ChipsDepositIconBlack.png',
    logoFullWidth: true,
    accountId: null,
    logoSize: 120,
    autoOpenFirstPaymentMethod: true,
    showTransactionOverview: true,
    scrollToPm: 'START',
    showAmountLimits: true,
    singlePageFlow: false,
    scrollToOffset: 0,
    accountDelete: true,
    showReceipt: true,
    autoProcess: false,
    globalSubmit: false,
    showTermsConditions: true,
    showBonusCode: false,
    allowCancelPendingWithdrawal: true,
    showListHeaders: true,
    listType: 'list',
    displayLogoOrName: 'both',
    recieptUrl: null,
    userCss: null
  },
  theme: {
    input: {
      color: '#222324',
      height: '52px',
      borderRadius: '4px'
    },
    inputbackground: {
      color: '#ffffff'
    },
    labels: {
      color: '#000000'
    },
    headings: {
      color: '#B7644B',
      fontSize: '12px'
    },
    loader: {
      color: '#46beab'
    },
    error: {
      color: '#ff2e56'
    },
    buttons: {
      color: '#F17759'
    },
    headerbackground: {
      color: '#F17759'
    },
    background: {
      color: '#ffffff'
    },
    cashierbackground: {
      color: '#ffffff'
    },
    cardbackground: {
      color: 'transparent'
    },
    border: {
      radius: '4px'
    },
    margin: {
      size: '14px'
    }
  },
  style
}

export default iGamingCanada
